import { useTranslation } from 'react-i18next'

import Button from '../../../Button'
import { PageEmptyState } from '../../../PageEmptyState'
import Text from '../../../Text'

import { QA_NAME_OVERVIEW_LOAD_RETRY } from './RentalPortalOverviewLoadError.constants'

import RefreshIcon from '../../../../icons/refresh.svg'
import StatisticIcon from '../../../../icons/statistic.svg'

function RentalPortalOverviewLoadError({ onClickRetry }) {
  const { t } = useTranslation()

  return (
    <PageEmptyState EntityIcon={StatisticIcon}>
      <Text isSecondary>{t('RentalPortal.OverviewErrorKey')}</Text>
      <Button.Flat
        beforeIconProps={{ Icon: RefreshIcon }}
        qaName={QA_NAME_OVERVIEW_LOAD_RETRY}
        text={t('RentalPortal.ListingRetryBtnKey')}
        onClick={onClickRetry}
      />
    </PageEmptyState>
  )
}

export default RentalPortalOverviewLoadError
